exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-ed57de64]{background-color:#0d6cf9!important}", ""]);

// exports
